<template>
  <div class="bienvenida-seccion">
    <div ref="bienvenidaRef" class="bienvenida-container">
      
      <img src="@/assets/esq-.png" alt="Decoración Superior Izquierda" class="flores-esq-sup-izq" ref="esqSupRef" />
      <img src="@/assets/esqq.png" alt="Decoración Inferior Derecha" class="flores-esq-inf-der" ref="esqInfRef" />

      <img 
        src="@/assets/CeremoCApi (1).webp" 
        alt="Candelabro Elegante" 
        class="candelabro-img" 
        ref="candelabroRef"
      />

      <p class="boda-subtitulo">NUESTRA BODA<br></p>
      <p class="boda-subtitulo">DE PERLAS</p>
<br>
      <h1 class="boda-nombres">
        MARISA <span class="ampersand-boda">y</span> MARTÍN
      </h1>
<br>
      <p class="boda-fecha">30 | DICIEMBRE | 2026</p>

      <div ref="mensajeRef" class="mensaje-bienvenida">
        {{ mensaje }}
      </div>

      <div ref="textoRef" class="nuevo-texto">
        ¡Nuestra historia continua!
      </div>

      <img src="@/assets/pareja.png" alt="Decoración Pareja" class="pareja-decorativa" ref="parejaRef" />
    </div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null);
    const candelabroRef = ref(null);
    const mensajeRef = ref(null);
    const textoRef = ref(null);
    
    // REFS PARA LAS FLORES DE LAS ESQUINAS
    const esqSupRef = ref(null);
    const esqInfRef = ref(null);

    // REF PARA LA PAREJA AGREGADA
    const parejaRef = ref(null);

    const mensaje = ref('');
    const text = `Cuando el amor es verdadero, el tiempo se detiene y el corazón encuentra su hogar eterno.`;

    const escribirTexto = (texto, index) => {
      if (index < texto.length) {
        mensaje.value += texto.charAt(index);
        setTimeout(() => escribirTexto(texto, index + 1), 45);
      }
    };

    onMounted(async () => {
      await nextTick();

      // Agrupamos los elementos de texto e imagen para una entrada limpia y consecutiva
      const elementosSecuenciales = [
        '.boda-subtitulo',
        '.boda-nombres',
        '.boda-fecha',
        textoRef.value
      ];

      // Configuración de estados iniciales discretos
      gsap.set(elementosSecuenciales, { opacity: 0, y: 20 });
      gsap.set(candelabroRef.value, { opacity: 0, scale: 0.9, y: 15 });
      gsap.set(bienvenidaRef.value, { opacity: 0 });
      
      // Ocultar e inicializar las flores y la pareja al final
      gsap.set([esqSupRef.value, esqInfRef.value], { opacity: 0, scale: 0.85 });
      gsap.set(parejaRef.value, { opacity: 0, y: 25, scale: 0.95 });

      // 1. Animación del contenedor principal al hacer scroll
      gsap.to(bienvenidaRef.value, {
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: bienvenidaRef.value,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });

      // 2. Línea de tiempo para la aparición ordenada de la gráfica y textos
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bienvenidaRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      });

      tl.to(candelabroRef.value, {
        opacity: 1,
        scale: 1,
        y: 0,
        duration: 1,
        ease: 'back.out(1.2)'
      })
      .to(elementosSecuenciales, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.2,
        ease: 'power3.out'
      }, '-=0.5')
      // Entrada elegante y sutil de las flores de las esquinas
      .to([esqSupRef.value, esqInfRef.value], {
        opacity: 1,
        scale: 1,
        duration: 1.2,
        stagger: 0.15,
        ease: 'power2.out'
      }, '-=0.4')
      // 🌟 ANIMACIÓN CONSECUTIVA PARA PAREJA.PNG al finalizar todo el bloque anterior
      .to(parejaRef.value, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1,
        ease: 'power2.out'
      }, '>-0.1');

      // 3. Disparador exclusivo para el efecto máquina de escribir
      ScrollTrigger.create({
        trigger: mensajeRef.value,
        start: 'top 80%',
        onEnter: () => escribirTexto(text, 0),
        once: true
      });

      // 4. Animación Infinita: Flotación sutil y elegante para el candelabro de oro
      gsap.to(candelabroRef.value, {
        y: '+=6',
        duration: 3,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    });

    return { 
      bienvenidaRef, 
      candelabroRef, 
      mensajeRef, 
      textoRef, 
      esqSupRef,
      esqInfRef,
      parejaRef,
      mensaje 
    };
  }
};
</script>

<style scoped>
.bienvenida-seccion {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.bienvenida-container {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 60px 20px 40px; /* Balanceado el padding para albergar los elementos nuevos de forma holgada */
  text-align: center;
  box-sizing: border-box;
  
  /* Configuración del fondo estético */
  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  overflow: hidden; /* Mantiene las flores dentro del marco redondeado */
}

/* ==========================================================================
   ESTILOS AGREGADOS: IMÁGENES DE LAS ESQUINAS
   ================================================================省 ========== */
.flores-esq-sup-izq {
   position: absolute;
  top: 0;
  left: 0;
  width: min(100px, 20vw);
  height: auto;
  pointer-events: none;
  z-index: 10;
  display: block;
  opacity: 1 !important; /* Salta la animación de GSAP */
}

.flores-esq-inf-der {
  position: absolute;
  bottom: 0;
  right: 0;
  width: min(130px, 35vw);
  height: auto;
  z-index: 1;
  pointer-events: none;
}

/* 🌟 ESTILOS NUEVOS PARA PAREJA.PNG AL FINAL */
.pareja-decorativa {
  width: 100%;
  max-width: 250px; /* Tamaño estético y refinado al fondo del módulo */
  height: auto;
  display: block;
  margin: 15px auto 0;
  z-index: 2;
  pointer-events: none;
}

/* Imagen del candelabro dorado de la temática */
.candelabro-img {
  width: 100%;
  max-width: 180px;
  height: auto;
  display: block;
  margin-bottom: 25px;
  filter: drop-shadow(0px 4px 8px rgba(0,0,0,0.1));
  z-index: 2;
}

/* Tipografías finas y limpias basadas en el diseño clásico */
.boda-subtitulo {
  font-family: 'padres', sans-serif;
  font-size: 19px;
  letter-spacing: 5px;
  color: #17218d;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  z-index: 2;
}

.boda-nombres {
  font-family: 'padres', serif;
  font-size: 28px;
  font-weight: 300;
  letter-spacing: 2px;
  color: #17218d;
  margin: 0 0 15px 0;
  line-height: 1.3;
  z-index: 2;
}

.ampersand-boda {
  font-family: 'Corinthia', cursive;
  font-size: 38px;
  display: block;
  margin: -5px 0;
  color: #17218d;
  font-weight: normal;
  text-transform: lowercase;
}

.boda-fecha {
  font-family: 'padres', sans-serif;
  font-size: 19px;
  letter-spacing: 4px;
  color: #17218d;
  margin: 0 0 25px 0;
  z-index: 2;
}

.mensaje-bienvenida {
  font-family: 'padres', sans-serif;
  font-size: 17px;
  line-height: 1.7;
  color: #4a4641;
  font-weight: 400;
  max-width: 85%;
  min-height: 55px; /* Evita pequeños saltos de layout al escribir */
  margin-bottom: 20px;
  white-space: pre-line;
  z-index: 2;
}

.nuevo-texto {
  font-family: 'Corinthia', cursive;
  font-size: 36px;
  color: #1c1c1b;
  margin-top: 10px;
  margin-bottom: 10px;
  z-index: 2;
}
</style>